import React, { ReactNode } from 'react';
import { Dialog } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './InstructionsDialog.less';

type InstructionsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  children?: ReactNode;
};

const InstructionsDialog = ({ isOpen, onClose, className, children }: InstructionsDialogProps) => {
  const contentClass = 'instructionsDialogContent' + (className ? ` ${className}` : '');
  
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className={contentClass}>
        <IconButton className="closeButton" onClick={onClose}>
          <CloseIcon/>
        </IconButton>
        {children}
      </div>
    </Dialog>
  );
};

export default InstructionsDialog;
